import React, { useEffect } from "react";
import { useCartData } from "@/zustand/cartStore.js";
import { useTemplateStore } from "@/zustand/templateStore.js";
import Button from "@/components/buttons/Button.jsx";
import PercentIcon from "@/public/fallbacks/percent.svg";

const UpsellPopup = () => {
  const { disableUpellPopup, setLoadingState, upsellPopup } = useTemplateStore();
  const { selectedProduct, setSelectedProduct } = useCartData();
  const form = window.post_template?.checkout_v4_form;
  /* Product data */
  const productDisplayName = window.post_template?.checkout_v4_products.upsell_popup_product_display_name;
  const productGenericTitle = window.post_template?.checkout_v4_products.upsell_popup_product_generic_name;
  const productSku = window.post_template?.checkout_v4_products.upsell_popup_product_sku;
  const productKonnId = window.post_template?.checkout_v4_products.upsell_popup_product_konn_id;
  const productImage = window.post_template?.checkout_v4_products.upsell_popup_product_image;
  const productPrice = window.post_template?.checkout_v4_products.upsell_popup_product_price;
  const productOldPrice = window.post_template?.checkout_v4_products.upsell_popup_product_old_price;
  const selectecProductAmount = selectedProduct?.amount;
  const totalAmount = productPrice * selectecProductAmount;

  /* Colors */
  const modalBgColor = window.post_template?.checkout_v4_products.upsell_popup_bg_color;
  const itemsLeftBgColor = window.post_template?.checkout_v4_products.upsell_popup_items_left_bg_color;
  const productCardBorderColor = window.post_template?.checkout_v4_products.upsell_popup_product_card_border_color;
  const productCardBgColor = window.post_template?.checkout_v4_products.upsell_popup_product_card_bg_color;
  const itemsLeftTextColor = window.post_template?.checkout_v4_products.upsell_popup_items_left_text_color;
  const noThanksLinkColor = window.post_template?.checkout_v4_products.upsell_popup_no_thanks_link_color;
  const priceColor = window.post_template?.checkout_v4_products.upsell_popup_price_color;
  const productCardLabelTextColor =
    window.post_template?.checkout_v4_products.upsell_popup_product_card_label_text_color;
  const textColorPrimary = window.post_template?.checkout_v4_products.upsell_popup_text_color_primary;
  const textColorSecondary = window.post_template?.checkout_v4_products.upsell_popup_text_color_secondary;
  const textColorDimmed = window.post_template?.checkout_v4_products.upsell_popup_text_color_dimmed;
  document.documentElement.style.setProperty("--upsell-popup-bg-color", modalBgColor);
  document.documentElement.style.setProperty("--items-left-bg-color", itemsLeftBgColor);
  document.documentElement.style.setProperty("--product-card-border-color", productCardBorderColor);
  document.documentElement.style.setProperty("--product-card-bg-color", productCardBgColor);
  document.documentElement.style.setProperty("--items-left-text-color", itemsLeftTextColor);
  document.documentElement.style.setProperty("--no-thanks-link-color", noThanksLinkColor);
  document.documentElement.style.setProperty("--price-color", priceColor);
  document.documentElement.style.setProperty("--product-card-label-text-color", productCardLabelTextColor);
  document.documentElement.style.setProperty("--text-primary-color", textColorPrimary);
  document.documentElement.style.setProperty("--text-secondary-color", textColorSecondary);
  document.documentElement.style.setProperty("--text-dimmed-color", textColorDimmed);

  const originalString = window.post_template?.checkout_v4_products.upsell_popup_product_desc || "";
  const replaceProductQty = (str, qty) => {
    return str.replace(/%%product_qty%%/g, qty);
  };
  const replacedString = replaceProductQty(originalString, selectecProductAmount);

  useEffect(() => {
    if (upsellPopup?.displayPopup) {
      document.body.style.setProperty("overflow", "hidden", "important");
    } else {
      document.body.style.removeProperty("overflow");
    }

    return () => {
      document.body.style.removeProperty("overflow");
    };
  }, [upsellPopup?.displayPopup]);

  const primaryProduct = selectedProduct?.bundle_products?.find((product) => product.primary_product === true);
  const modifiedBundleProducts = selectedProduct.bundle_products?.map((product) => {
    if (product === primaryProduct) {
      return {
        ...product,
        bp_price: productPrice,
        bp_sku: productSku,
        bp_konnektive_id: productKonnId,
      };
    } else {
      return product;
    }
  });

  const handleUpsellClick = () => {
    setSelectedProduct({
      ...selectedProduct,
      generic_name: productGenericTitle,
      display_name: productDisplayName,
      price: productPrice,
      old_price: productOldPrice,
      bundle_products: modifiedBundleProducts,
    });
    disableUpellPopup();
    setLoadingState(true);
  };

  const closeUpsellPopup = () => {
    disableUpellPopup();
  };

  useEffect(() => {
    setTimeout(() => {
      closeUpsellPopup();
    }, [window.post_template?.checkout_v4_products.upsell_popup_submit_without_upsell * 1000 || 10000]);
  }, []);
  return (
    <div className="upsellPopup upsells-modal__wrapper upsells-modal__wrapper--active">
      <div className="upsellPopup__alert">
        <div
          className="upsellPopup__alertIcon"
          style={{
            maskImage: `url(${PercentIcon})`,
            WebkitMaskImage: `url(${PercentIcon})`,
          }}
        />
        <div className="upsellPopup__alertMessage">
          {window.post_template?.checkout_v4_products.upsell_popup_items_left_label}
        </div>
      </div>
      <div className="upsellPopup__heading">
        <span>{window.post_template?.checkout_v4_products.upsell_popup_heading}</span>
        <div className="upsellPopup__subHeading">
          {window.post_template?.checkout_v4_products.upsell_popup_subheading}
        </div>
      </div>
      <div className="upsellPopup__content">
        <img
          src={productImage}
          className="upsellPopup__image upsellPopup__image--desktop mon-img-150-w"
          alt={`${general_settings.brand_name} image`}
        />
        <div>
          <div className="productListPopup__item productListPopup__item--enabledBorder productList__item--enabledBorder productListPopup__item--SDCard">
            <div className="productListPopup__popular productListPopup__popular--enabled">
              {window.post_template?.checkout_v4_products.upsell_popup_exclusive_deal_label}
            </div>
            <div className="productListPopup__contentDiff">
              <div className="productListPopup__priceDiff">
                <span className="product-card-price">{productPrice}</span>
                <span className="product-card-quantity">
                  <s>{productOldPrice}</s>
                </span>
                <span></span>
                <span>{window.post_template?.checkout_v4_products.upsell_popup_each_label}</span>
              </div>
              <span className="productListPopup__messageDiff">{replacedString}</span>
              <div className="productListPopup__totalDiff">
                {window.post_template?.checkout_v4_products.upsell_popup_total_label}: {totalAmount?.toFixed(2)}
              </div>
            </div>
          </div>
          <Button
            margin={16}
            text={form?.tr_checkout_v4_form_cta}
            processingLabel={form?.tr_checkout_v4_form_processing}
            loading={false}
            handleClick={handleUpsellClick}
          />
          <a
            className="cta-decline btn-cancel"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              disableUpellPopup();
            }}
          >
            {window.post_template?.checkout_v4_products.upsell_popup_no_thanks_link_label}
          </a>
        </div>
      </div>
    </div>
  );
};

export default UpsellPopup;
